module.exports = __webpack_public_path__ + "static/rcc-orr-final-desktop-4c62feb9e79d169179d90b3949c8d09e.png";